import React, { useRef, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

import { LeftArrowIcon, RightArrowIcon } from "../../../assets/svg";

import { SkeletonPopularCategory } from "../../CommonComponents/SkeletonUI/LandingPageSkeleton";

export default function PopularCategorySection({ isMobile, handleLinkClick, popularCategoryData, isAuthenticated, isLoading }) {
  const swiperRef = useRef(null); // Ref to access the Swiper instance
  const [currentSlide, setCurrentSlide] = useState(0); // Track current slide index

  const totalSlides = popularCategoryData?.length;

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  const responsiveBreakpoints = {
    1300: { slidesPerView: 8, spaceBetween: 16 },
    1280: { slidesPerView: 7, spaceBetween: 16 },
    1024: { slidesPerView: 6, spaceBetween: 16 },
    950: { slidesPerView: 5.5, spaceBetween: 16 },
    850: { slidesPerView: 5, spaceBetween: 16 },
    769: { slidesPerView: 4.5, spaceBetween: 16 },
    768: { slidesPerView: 6, spaceBetween: 16 },
    600: { slidesPerView: 5, spaceBetween: 16 },
    400: { slidesPerView: 4.2, spaceBetween: 16 },
    350: { slidesPerView: 3.5, spaceBetween: 16 },
    300: { slidesPerView: 2.5, spaceBetween: 16 },
    0: { slidesPerView: 2.5, spaceBetween: 16 },
  };

  return isLoading ? (
    <SkeletonPopularCategory />
  ) : popularCategoryData !== null && totalSlides > 0 ? (
    <div className="container flex flex-col mb-8 md:my-8 md:pt-0 pl-5 -pr-5 md:px-5 mx-auto relative">
      <div className="flex">
        <div className="font-semibold font-Inter text-xl md:text-3xl pb-4 md:pb-6">
          {isMobile ? "" : "Popular"} Categories
        </div>
        <button onClick={handlePrev} className="carousel-custom-arrow left-arrow">
          <LeftArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === 0 ? "#737373" : "#000"}]`} />
        </button>

        <button onClick={handleNext} className="carousel-custom-arrow right-arrow">
          <RightArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === totalSlides - 1 ? "#737373" : "#000"}]`} />
        </button>
      </div>

      <div className="carousel-wrapper">
        <Swiper
          ref={swiperRef}
          modules={[Autoplay, Navigation]}
          spaceBetween={16}
          slidesPerView={8}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
          breakpoints={responsiveBreakpoints}
          loop={true}
        >
          {popularCategoryData?.map((item) => (
            item?.bg_image !== undefined && (
              <SwiperSlide key={item?.id}>
                <Link
                  to={isAuthenticated ? `/rewards/?filters={"brand_categories":[${item.id}]}` : "/"}
                  onClick={() => handleLinkClick(item, { popularCategory: true }, false, false)}
                  className="flex flex-col items-start md:justify-between"
                  state={item}
                >
                  <div
                    className={`${isMobile ? "w-[65px] h-[65px]" : "w-[100px] h-[100px]"} rounded-full bg-center bg-[#EFEFEF] bg-no-repeat bg-cover`}
                    style={{ backgroundImage: `url('${item?.bg_image}')`, backgroundColor: "#EFEFEF" }}
                  ></div>

                  <div className={`text-sm md:text-lg text-[#1E1E1E] font-medium w-16 md:w-24 text-center pt-2 font-Inter-Tight`}>
                    {item?.name}
                  </div>
                </Link>
              </SwiperSlide>
            )
          ))}
        </Swiper>
      </div>
    </div>
  ) : null;
}